import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { BiEdit } from 'react-icons/bi';
import { AiFillCheckCircle } from 'react-icons/ai';
import { formatToTimeZone } from 'date-fns-timezone';
import {
  Label,
  EditableDateInput,
  EditableTextInput,
  EditableSelect,
  SaveWrapper,
  Placeholder
} from './styled';

const EditableInput = ({ formik, name, type, onSave, loadingField }) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const isCurrentLoading = loadingField === name;
  const isLoading = loadingField;
  const hasErrors = formik.errors[name];

  const renderInputField = () => {
    if (type === 'date') {
      return (
        <EditableDateInput
          disabled={isLoading}
          variant="small"
          formik={formik}
          name={name}
          showCaret={false}
        />
      );
    }

    if (type === 'text') {
      return (
        <EditableTextInput
          disabled={isLoading}
          variant="light"
          formik={formik}
          name={name}
        />
      );
    }

    if (type === 'gender') {
      return (
        <EditableSelect
          disabled={isLoading}
          variant="small"
          options={[
            { label: 'Female', value: 'female' },
            { label: 'Male', value: 'male' }
          ]}
          formik={formik}
          name={name}
        />
      );
    }
  };

  const toggleEditMode = () => {
    setIsEditMode(!isEditMode);
  };

  const renderValue = () => {
    if (type === 'date') {
      return formik.values[name] ? (
        formatToTimeZone(new Date(formik.values[name]), 'MMMM D, YYYY', {
          timeZone: 'Etc/UTC'
        })
      ) : (
        <Placeholder onClick={toggleEditMode}>Choose your birthdate</Placeholder>
      );
    }

    if (type === 'gender') {
      return formik.values[name] ? (
        formik.values[name][0].toUpperCase() + formik.values[name].slice(1)
      ) : (
        <Placeholder onClick={toggleEditMode}>Choose your gender</Placeholder>
      );
    }

    return formik.values[name];
  };

  return (
    <Label>
      {!isEditMode && (
        <>
          {renderValue()}
          <BiEdit onClick={toggleEditMode} />
        </>
      )}
      {isEditMode && (
        <>
          {renderInputField()}
          <SaveWrapper
            disabled={hasErrors}
            onClick={() => {
              if (!hasErrors) {
                onSave([name], setIsEditMode);
              }
            }}
          >
            <AiFillCheckCircle />
            <span>{isCurrentLoading ? 'Saving...' : 'Save'}</span>
          </SaveWrapper>
        </>
      )}
    </Label>
  );
};

EditableInput.propTypes = {
  formik: PropTypes.object,
  name: PropTypes.string,
  type: PropTypes.string,
  onSave: PropTypes.func,
  loadingField: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

export default EditableInput;
